import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbContextService } from '../../../services/db-context.service';
import { Helper } from '../../common/helper';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class OrderCartService {

  constructor(private http: HttpClient, private dbxService: DbContextService) { }

  getOrderHeaderDetailsIndexDb(orderId: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderInfoHeader', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }

        let store = tx.objectStore('OWS_tblOrderInfoHeader');
        store.get(orderId).then(
          (res: any) => {
            resolve(res);
          }
        )
      })
    });

    return promise;
  }

  getOrderHeaderDetailsTemp(orderInfoHeaderID: string) {
    // convert to httpPost
    let paramObject = {
      'orderInfoHeaderID': orderInfoHeaderID
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetOrderInfoHeaderComponentTemp', paramObject);
  }

  getOrderHeaderDetails(orderInfoHeaderID: string) {
    // convert to httpPost
    let paramObject = {
      'orderInfoHeaderID': orderInfoHeaderID
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetOrderInfoHeaderComponent', paramObject);
  }

  getOrderDetailsTemp(orderInfoHeaderID: string) {
    // convert to httpPost
    let paramObject = {
      'orderInfoHeaderID': orderInfoHeaderID
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetGroupedOrderInfoDetailDataTemp', paramObject);
  }

  getOrderDetails(orderInfoHeaderID: string) {
    // convert to httpPost
    let paramObject = {
      'orderInfoHeaderID': orderInfoHeaderID
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetGroupedOrderInfoDetailData', paramObject);
  }

  getShipDetails() {
    return this.http.get(Helper.API_URL() + `/api/Maintenance/GetShips/0`);
  }

  getAverageManDay(deptID: number, periodFrom: string, periodTo: string) {

    // convert to httpPost
    let paramObject = {
      'deptID': deptID,
      'periodFrom': periodFrom,
      'periodTo': periodTo
    }

    return this.http.post(Helper.API_URL() + '/api/orders/GetAverageManDay', paramObject);
  }

  getQuantityMultiplier() {

    return this.http.post(Helper.API_URL() + '/api/orders/GetQuantityMultiplier', {});
  }

  getNeededAndEstimatedES(suppliersProductsID: number, departmentID: number, periodFrom: string, periodTo: string, noOfDays: number, noOfDaysFreshFood: number, noOfCrew: number, overrideAvgMD1: any, overrideAvgMD2: any, overrideContractManDay: any, isNewOrder: boolean) {

    // convert to httpPost
    let paramObject = {
      'suppliersProductsID': suppliersProductsID,
      'departmentID': departmentID,
      'periodFrom': periodFrom,
      'periodTo': periodTo,
      'noOfDays': noOfDays,
      'noOfDaysFreshFood': noOfDaysFreshFood,
      'noOfCrew': noOfCrew,
      'overrideAvgMD1': overrideAvgMD1,
      'overrideAvgMD2': overrideAvgMD2,
      'overrideContractManDay': overrideContractManDay,
      'isNewOrder': isNewOrder
    }

    return this.http.post(Helper.API_URL() + '/api/orders/GetNeededAndEstimatedES', paramObject);
  }

  getAdjustedOrderProposal(departmentID: number, periodFrom: string, periodTo: string, noOfDays: number, noOfCrew: number, supplierID: number, harborID: number, isHolidayOrder: boolean, isExtraList: boolean, proposalList: any[]) {

    // convert to httpPost
    let paramObject = {
      'departmentID': departmentID,
      'periodFrom': periodFrom,
      'periodTo': periodTo,
      'noOfDays': noOfDays,
      'noOfCrew': noOfCrew,
      'supplierID': supplierID,
      'harborID': harborID,
      'isHolidayOrder': isHolidayOrder,
      'isExtraList': isExtraList,
      'proposalList': proposalList,
    }

    return this.http.post(Helper.API_URL() + '/api/orders/GetAdjustedOrderProposal', paramObject);
  }

  getOrderListByOrderID(orderInfoHeaderID: number) {

    // convert to httpPost
    let paramObject = {
      'orderInfoHeaderID': orderInfoHeaderID
    }

    return this.http.post(Helper.API_URL() + '/api/orders/OWSGetOrderListGroupByOrderID', paramObject);
  }

  getAllSubmittedPending(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewSubmitted');
        store.getAll().then(
          (res: any[]) => {
            let list: any[] = [];

            //get submitted not marked as delivered
            res.forEach((order: any) => {
              if ((order.isDelivered == null) || !order.isDelivered) {
                list.push(order);
              }
            });
            resolve(list);
          })
      });
    });
    return promise;
  }

  getShipDetailsIndexDb(shipID: number): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblShips', 'readwrite');
        let store = tx.objectStore('OWS_tblShips');
        store.getAll().then(
          (res: any[]) => {
            let list: any[] = [];
            res.forEach((ship: any) => {
              if (ship.shipID == shipID) {
                list.push(ship);
              }
            });
            resolve(list);
          })
      });
    });
    return promise;
  }

  getShipBudgetInfoIndexDb(orderID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblShipBudgetInfo', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblShipBudgetInfo');
        store.get(orderID).then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });
    return promise;
  }

  getOrderDetailIndexDb(orderID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderDetail', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderDetail');
        store.get(orderID).then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });
    return promise;
  }

  getProductProposedQuantityIndexDb(orderWeightByCategoryID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderWeightByCategory', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderWeightByCategory');
        store.get(orderWeightByCategoryID).then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });
    return promise;
  }

  updateOrderDetailIndexDb(orderID: string, orderDetailList: any): Promise<Object> {
    const obj = {
      orderID: orderID,
      orderDetailList: orderDetailList,

    };

    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderDetail', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };
        let store = tx.objectStore('OWS_tblOrderDetail');
        try {
          let req = store.put(obj).then(
            (res: any) => {
              resolve(res);
            }
          );
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }

        tx.done;// complete;

      });
    });
    return promise;
  }

  saveSuggestedQuantityIndexDB(orderId: any, suggestedQuantityList: any): Promise<Object> {
    let obj = {
      orderID: orderId,
      suggestedQuantityList: suggestedQuantityList
    }
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblSuggestedQuantity', 'readwrite');
        tx.oncomplete = (ev) => {

        }

        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }

        let store = tx.objectStore('OWS_tblSuggestedQuantity');
        try {
          let req = store.add(obj).then(
            (res: any) => {
              resolve(res);
            }
          )
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
      })
    })

    return promise;
  }

  getSuggestedQuantitiesIndexDB(orderId: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblSuggestedQuantity', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }

        let store = tx.objectStore('OWS_tblSuggestedQuantity');
        let req = store.get(orderId).then(
          (res: any) => {
            resolve(res);
          }
        )
      })
    })

    return promise;
  }

  deleteOrderHeaderIndexDb(orderInfoHeaderID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderInfoHeader', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderInfoHeader');
        let req = store.delete(orderInfoHeaderID);

        tx.done;// complete;

        resolve(true);
      });
    });
    return promise;
  }

  deleteOrderDetailsIndexDb(orderID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblOrderDetail', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblOrderDetail');
        let req = store.delete(orderID);

        tx.done;// complete;

        resolve(true);
      });
    });
    return promise;
  }

  deleteOrderWeightByCategoryIndexDb(orderHeaderKey: string) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblOrderWeightByCategory', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onerror = (err: any) => {
        console.warn(err);
      }
      let store = tx.objectStore('OWS_tblOrderWeightByCategory');
      let req = store.delete(orderHeaderKey);

      return tx.done;// complete;
    });
  }

  updateOpenOrderInfoOverviewIndexDB(orderHeaderData: any): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewOpen', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewOpen');

        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.get(orderHeaderData.orderInfoHeaderID).then(
          (res: any) => {
            if (res) {
              res.isUpdatedOffline = true;
              res.wsStatusDesc = orderHeaderData.wsStatusDesc;

              try {
                store.put(res).then((res2: any) => {
                  resolve(res2);
                });
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            } else {
              resolve(null);
            }
          }
        )
      });
    });

    return promise;
  }

  updateOpenToSubmittedOrderInfoOverviewIndxDb(orderHeaderData: any): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewOpen', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewOpen');

        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.get(orderHeaderData.orderInfoHeaderID).then(
          (res: any) => {
            if (res) {

              res.isUpdatedOffline = true;
              res.wsStatusDesc = orderHeaderData.wsStatusDesc;
              let orderHeaderObj = Helper.deepCopy(res);

              let tx2 = db.transaction('OWS_tblOrderOverviewSubmitted', 'readwrite');
              let store2 = tx2.objectStore('OWS_tblOrderOverviewSubmitted');

              store.delete(orderHeaderData.orderInfoHeaderID);
              try {
                store2.put(orderHeaderObj).then((res2: any) => {
                  resolve(res2);
                });
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            } else {
              resolve(null);
            }
          }
        )
      });
    });

    return promise;
  }

  processCreateOrderInfoDataTemp(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Orders/ProcessCreateOrderInfoDataTemp', data);
  }

  processUpdateOrderInfoDataTemp(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Orders/ProcessUpdateOrderInfoDataTemp', data);
  }

  processCreateOrderInfoData(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Orders/ProcessCreateOrderInfoData', data);
  }

  processUpdateOrderInfoData(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Orders/ProcessUpdateOrderInfoData', data);
  }

  getSuggestedQuantities(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Orders/GetSuggestedQuantities', data);
  }

  deleteOrderWSTemp(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Orders/DeleteOrderWSTemp', data);
  }

  getBeginStockTransDate(deptID: number) {

    // convert to httpPost
    let paramObject = {
      'deptID': deptID
    }

    return this.http.post(Helper.API_URL() + '/api/Budget/GetBeginStockTransDate', paramObject);
  }

  getSupplier(supplierID: any) {
    return this.http.get(Helper.API_URL() + '/api/Supplier/GetSupplier/' + supplierID);
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
